import { getBorderBase, getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import Button from 'components/Button';
import { COMPONENTS_NAMES } from 'theme/constants';

const prefix = ['components', COMPONENTS_NAMES.FILTERS, 'sectionItem', 'scope'];

export const Container = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  & > * {
    min-height: 30px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  border-radius: 8px;
  padding: 10px;
  border-style: solid;
  ${getBorderBase(prefix)};
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 10px;
`;

export const RemoveSection = styled(Button)`
  min-width: 12px;
  min-height: 12px;
  border-radius: ${getPrefixedVar(prefix, 'removeButton', 'borderRadius')}!important;

  svg {
    color: ${getPrefixedVar(prefix, 'removeButton', 'icon')};
  }
`;
